<template>
  <div class="c-multiplayer-page" v-if="isAuth" @scroll="onScroll">
    <DeactivatedEmptyState v-if="isDeactivated" title="Multiplayer"></DeactivatedEmptyState>
    <Multiplayer v-else ref="multi"></Multiplayer>
  </div>
</template>

<script>
import Multiplayer from "@swipekit/components/multiplayer";
import DeactivatedEmptyState from "@/components/deactivated-empty-state.vue";

export default {
  components: {
    Multiplayer,
    DeactivatedEmptyState,
  },

  computed: {
    isAuth: function () {
      return this.$store.getters["users/isAuth"];
    },
    isDeactivated: function () {
      return this.$store.getters["users/isTrialOver"];
    },
  },

  methods: {
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (this.isDeactivated) {
        return;
      }
      let buffer = 200;
      if (scrollTop + clientHeight >= scrollHeight - buffer) {
        this.$refs.multi.onEnd();
      } else {
      }
    },
  },
};
</script>

<style lang="scss">
.c-multiplayer-page {
  height: 100vh;
  position: relative;
  overflow-y: auto;
}
</style>
